var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "casino-launcher-overlay" }, [
    _c(
      "div",
      { staticClass: "casino-launcher-overlay-wrapper" },
      [
        !_vm.iFrameLoaded ? _c("circle-loader") : _vm._e(),
        _vm._v(" "),
        _c("iFrame", {
          ref: "casinoGameReference",
          staticClass: "casinoGameIframe",
          staticStyle: { border: "none" },
          attrs: {
            src:
              _vm.sortUrl(_vm.casino.ORIGIN) +
              "/" +
              this.casinoLicenseId +
              "/" +
              this.gameData.id +
              "?lang=en&cur=" +
              this.gameData.userCurrencyCode +
              "&mode=" +
              _vm.casino.MODE +
              "&user=" +
              this.gameData.username +
              "&uid=" +
              this.gameData.userId +
              "&token=" +
              this.gameData.token +
              "&lobbyURL=" +
              _vm.returnToCasinoPage,
            id: "casinoIframe",
            width: _vm.calculatedWith,
            height: _vm.calculatedHeight,
            allowfullscreen: ""
          },
          on: { load: _vm.iframeLoaded }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cae9e8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cae9e8a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/igaming/partials/casinoLauncher.vue
// module id = null
// module chunks = 